import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import Label from "./Label";
import Box from "./Box";
import { css } from "./Theme";
import FrameInternals from "./FrameInternals";
import useDocumentState from "../hooks/useDocumentState";
const {
  useMemo
} = React;

const Frame = props => {
  const [documentScale] = useDocumentState("scale");
  const scale = documentScale ? documentScale / 100 : 1;
  const width = useMemo(() => props.width * scale, [props.width, scale]);
  const height = useMemo(() => props.height * scale, [props.height, scale]);
  const frameStyles = css({
    width: `${width}px`,
    m: `${32 * scale}px`
  });
  const frameContentsStyles = css({
    transform: `scale(${scale}, ${scale})`,
    transformOrigin: "top left"
  });
  const viewable = css({
    width: `${width}px`,
    height: `${height}px`,
    overflow: "hidden"
  });
  return ___EmotionJSX(Box, {
    css: frameStyles
  }, ___EmotionJSX(Label, {
    uppercase: false
  }, props.title), ___EmotionJSX(Box, null, ___EmotionJSX(Box, {
    css: viewable
  }, ___EmotionJSX(FrameInternals, {
    css: frameContentsStyles,
    width: props.width,
    height: props.height
  }, props.children))));
};

export default Frame;